"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

exports.__esModule = true;

var React = require("react");

var elements_1 = require("../react-inspector/elements");

var devtools_parser_1 = require("../devtools-parser");

var Formatted =
/** @class */
function (_super) {
  __extends(Formatted, _super);

  function Formatted() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Formatted.prototype.render = function () {
    return React.createElement(elements_1.Root, {
      "data-type": "formatted",
      dangerouslySetInnerHTML: {
        __html: devtools_parser_1["default"](this.props.data || [])
      }
    });
  };

  return Formatted;
}(React.PureComponent);

exports["default"] = Formatted;